export default "__VITE_ASSET__oXFT5tZf__"